import { Suspense } from "react";
import { LazyRootRoute } from "./constant/lazyImports";
import { getAccessToken } from "./utils/tokenStorage";
import DashboardLayoutSkeleton from "./components/skeleton/DashboardSkleton";
import AuthLayoutSkeleton from "./components/skeleton/AuthSkelton";
import { useLocation } from "react-router-dom";
import { openMainLayoutRoutes } from "./data/data";
import RoDetailModalHost from "./pages/inventory/in-repair/components/RoDetailModalHost";
import { isRoDetailDeepLink } from "./pages/inventory/in-repair/utils/inRepairRoDetailUtils";

const App = () => {
  const token = getAccessToken();
  const location = useLocation();
  const isDeepLink = isRoDetailDeepLink(location);

  return (
    <>
      <RoDetailModalHost />
      <Suspense
        fallback={
          isDeepLink ? null : !!token ||
            openMainLayoutRoutes.includes(location.pathname) ? (
            <DashboardLayoutSkeleton />
          ) : (
            <AuthLayoutSkeleton />
          )
        }
      >
        <LazyRootRoute />
      </Suspense>
    </>
  );
};

export default App;
